import Vue from 'vue'

/**
 * Custom directives.
 */
import FloatLabel from './float-label'
import CollapseStepper from './collapse-stepper'
import Drawer from './drawer'
import Sortable from './sortable'

Vue.directive('float-label', FloatLabel)
Vue.directive('collapse-stepper', CollapseStepper)
Vue.directive('drawer', Drawer)
Vue.directive('sortable', Sortable)



// WEBPACK FOOTER //
// ./src/directives/index.js